import Connections from "./views";

export default Connections